<template>
  <section id="service" class="n2-seccion" v-if="S?.Mostrar && servicios.length">
    <div class="n2-contenedor">
      <div class="n2-cabeza-seccion n2-aparece">
        <h2 class="n2-titulo-seccion">
          <NuxtLink :to="getLocalePath('/servicios')"><span v-html="S.Titulo?.Texto || tituloSeccion(NOTARIA, 'Servicios', $t)"></span></NuxtLink>
        </h2>
        <div v-if="S.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(S.Descripcion.css)" v-html="S.Descripcion.Texto"></div>
      </div>

      <!-- "¿Qué necesita?": el visitante elige un servicio y ve en qué consiste y cómo empezar.
           Sin tarjetas debajo, que repetían los mismos servicios (ref: https://trello.com/c/wpT5ymxH) -->
      <div class="n2-selector n2-aparece">
        <p class="n2-selector__pregunta">{{ tSolicitud('¿Qué necesita?') }}</p>
        <div class="n2-chips" role="tablist">
          <button v-for="(s, i) in servicios" :key="s.id ?? i" type="button" role="tab" class="n2-chip"
            :class="{ 'n2-chip--activo': i === elegido }" :aria-selected="i === elegido" @click="elegido = i">
            {{ s.Titulo }}
          </button>
        </div>
        <div v-if="actual" class="n2-selector__panel" role="tabpanel">
          <div>
            <h3>{{ actual.Titulo }}</h3>
            <p>{{ resumen(actual) }}</p>
          </div>
          <div class="n2-selector__acciones">
            <NuxtLink v-if="acceso.visible('servicios') && acceso.tramiteDeServicio(actual)" class="n2-boton n2-boton--acento"
              :to="acceso.enlace('servicios', acceso.tramiteDeServicio(actual))">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
            <NuxtLink class="n2-boton n2-boton--linea" :to="enlaceServicio(actual)">{{ tSolicitud('Más información') }}</NuxtLink>
          </div>
        </div>
      </div>

      <div v-if="S.ShowButton && S.Button?.Texto" class="n2-centrado">
        <NuxtLink class="n2-boton n2-boton--linea" :to="getLocalePath('/servicios')">{{ S.Button.Texto }}</NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, alineacionTexto } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()

// Panel: Inicio → Servicios (título, descripción, botón) y los servicios marcados "Mostrar en inicio"
const S = computed(() => NOTARIA.value?.Theme?.Home?.Servicios)
const servicios = computed(() => (NOTARIA.value?.Servicios ?? []).filter(s => s.Publicado && s.MostrarHome))
const elegido = ref(0)
const actual = computed(() => servicios.value[elegido.value] ?? servicios.value[0])

const enlaceServicio = (s) => getLocalePath('/servicios/' + s.Slug) + '?from=home'

const resumen = (s) => textoPlano(s.Extracto || s.Subtitulo || s.Contenido, 260)
</script>
